module.exports = __webpack_public_path__ + "static/media/icon_137.3c1f24fd.png";